import { __decorate } from "tslib";
import { Component, Vue } from "../../../vue";
import { IMethodEditorState } from "../MethodEditorState";
let MethodCodeEditor = class MethodCodeEditor extends Vue {
  mounted() {
    const {
      el
    } = this.$refs;
    this.state.initCodeEditor(el);
  }
  get style() {
    return {
      width: '100%',
      height: '800px'
    };
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "ref": "el",
      "attrs": {
        "guide-el": "method-code-editor"
      },
      "style": this.style
    });
  }
};
__decorate([IMethodEditorState], MethodCodeEditor.prototype, "state", void 0);
MethodCodeEditor = __decorate([Component({
  name: 'MethodCodeEditor'
})], MethodCodeEditor);
export default MethodCodeEditor;
//# sourceMappingURL=MethodCodeEditor.js.map
